import React from 'react'

import ProjectSession from "../../../model2/project/project-session"
import {ProjectAccessMode} from "../../../model2/project/types";

type Props = {
    project: ProjectSession
}

export default class UsersQuickLink extends React.Component<Props> {

    onClick = () => {
        gd.goTo('p/{0}/info/users'.f(this.props.project.id))
        // gd.goTo("p/"+this.props.project.id+'/users')
    }

    renderUsers(total:number) {
        return (
            <div className="ui5-sharing m-r-8" onClick={this.onClick}>
                <div className="i5-users"/>
                <span className="total">{total}</span>
            </div>
        )
    }

    renderPrivate() {
        return <div className="ui5-ico-lock m-r-8" onClick={this.onClick}/>
    }

    renderPublic() {
        return <div className="ui5-ico-12 i5-globe m-r-8" onClick={this.onClick}/>
    }

    render() {
        if (this.props.project.isTemplate) return null

        const standardAccess = gd.ac.check.project.standardAccess(this.props.project.id, this.props.project)
        if (!standardAccess) return null

        const projectUsers = gd.session.projectUsers.notClients(this.props.project.id)
        const usersNumber = projectUsers.length

        if(this.props.project.isTag) {
            switch (this.props.project.accessMode) {
                case ProjectAccessMode.PUBLIC_INHERITANCE_CHILDREN:
                    return this.renderPublic()

                default:
                    if (usersNumber === 1)  return this.renderPrivate()
            }
        }

        return this.renderUsers(usersNumber)
    }
}